import { get } from "@qtxr/utils";

import {
	traverse,
	collectLayout
} from "../../common";
import PlotSvg from "../../plot-svg";

import {
	Group,
	Point,
	DataPoint
} from "../../apply-categorization";

const HorizontalBarConfig = {
	name: "horizontal-bar",
	collector: () => collectLayout((p: any) => {
		p.data.totals = p.data.nodes.map((node: Point | Group, idx: number) => {
			return traverse.points.reduce(node, (acc, point) => {
				return acc + get(p.data.points[idx], point.accessor).value
			}, 0);
		});

		p.data.max = Math.max(...p.data.totals);

		return p.data;
	}),
	plotter: () => (p: any) => {
		const plot = new PlotSvg(p);

		const ds = p.dataset,
			offset = 100,
			w = ds.cWidth - offset,
			h = ds.cHeight,
			max = ds.data.max,
			space = 8,
			barHeight = (h - (space * (ds.data.nodes.length - 1))) / ds.data.nodes.length,
			groupLabel = ds.groupLabel,
			labelAllPoints = ds.labelAllPoints;
		let y = 0,
			groupData = [] as DataPoint[];

		plot.forEach(({ node, style }) => {
			let x = offset;

			plot.text(node.label)
				.x(x - 10)
				.y(y + barHeight / 2)
				.maxLength((x - 10) / 5)
				.size(10)
				.weight(600)
				.anchor("end")
				.baseline("middle")
				.fill(style.fullTheme.color)
				.inert();

			plot.forEachPoint(pt => {
				const width = (pt.value / max) * w,
					boundaryType = plot.getBoundaryType("nested");

				if (groupLabel && (boundaryType?.includes("start") || boundaryType?.includes("junction") || labelAllPoints))
					plot.pushBounding();
				if (groupLabel)
					groupData.push(pt.data);

				plot.rect()
					.x(x)
					.y(y)
					.width(width)
					.height(barHeight)
					.fill(pt.color);

				if (!boundaryType?.includes("start")) {
					const separatorWidth = boundaryType?.includes("junction") ?
						1.5 :
						0.5;

					plot.line()
						.x1(x)
						.y1(y)
						.v(barHeight)
						.stroke(pt.style.fullTheme.graphBackground)
						.strokeWidth(separatorWidth)
						.stack(1);
				}

				if (groupLabel && (boundaryType?.includes("end") || labelAllPoints)) {
					const bounding = plot.popBounding();

					plot.text(groupLabel(groupData))
						.x(bounding.x + bounding.width / 2)
						.y(bounding.y + bounding.height / 2)
						.maxLength(bounding.width / 6)
						.hideIfTooLong(true)
						.size(10)
						.weight(600)
						.anchor("middle")
						.baseline("middle")
						.shadow(style.fullTheme.textShadow)
						.fill(style.fullTheme.accentColor)
						.stack(2)
						.inert();

					groupData = [];
				}

				x += width;
			});

			y += (space + barHeight);
		});

		plot.render();
	},
	dataset: {
		id: "horizontal-bar",
		mode: "own",
		type: "horizontal-bar",
		canvasType: "svg",
		renderInfoBox: false,
		autoHeight: true,
		data: {}
	}
};

export default HorizontalBarConfig;
